import '@/styles/global.scss';
import '@/assets/images/favicon.ico';
import React from 'react';
import Routing from '@/app.routing';

const AppComponent = () => (<Routing></Routing>)

export default AppComponent;
